import { Link } from 'next-view-transitions';

export const TransitionLink = ({
  href,
  children,
  ...props
}: {
  href: string
  children: React.ReactNode
  [key: string]: any
}) => {
  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
};
